// extracted by mini-css-extract-plugin
var _1 = "SchoolDropdown__crumbArrow--RxOAS";
var _2 = "SchoolDropdown__crumbContainer--lWGVi";
var _3 = "SchoolDropdown__crumbMain--xwZOM SchoolDropdown__mainBase--uUot2";
var _4 = "SchoolDropdown__crumbOpenArrow--P_UHg";
var _5 = "SchoolDropdown__crumbOpenPreview--SL3Nx";
var _6 = "SchoolDropdown__crumbPreview--QK5GY";
var _7 = "SchoolDropdown__defaultOption--PE1RB";
var _8 = "SchoolDropdown__mainBase--uUot2";
var _9 = "SchoolDropdown__option--OIY5X";
var _a = "SchoolDropdown__preview--q2fyA";
var _b = "SchoolDropdown__previewDefault--MXX7g";
var _c = "SchoolDropdown__rectangleArrow--zExqJ";
var _d = "SchoolDropdown__rectangleContainer--HEfRa";
var _e = "SchoolDropdown__rectangleMain--XGFoc SchoolDropdown__mainBase--uUot2";
var _f = "SchoolDropdown__rectanglePreview--xlqA9 SchoolDropdown__preview--q2fyA";
var _10 = "SchoolDropdown__roundedArrow--WFG0N";
var _11 = "SchoolDropdown__roundedContainer--fcRsh";
var _12 = "SchoolDropdown__roundedMain--zpcny SchoolDropdown__mainBase--uUot2";
var _13 = "SchoolDropdown__roundedOpenArrow--ama1w";
var _14 = "SchoolDropdown__roundedPreview--RurKF SchoolDropdown__preview--q2fyA";
export { _1 as "crumbArrow", _2 as "crumbContainer", _3 as "crumbMain", _4 as "crumbOpenArrow", _5 as "crumbOpenPreview", _6 as "crumbPreview", _7 as "defaultOption", _8 as "mainBase", _9 as "option", _a as "preview", _b as "previewDefault", _c as "rectangleArrow", _d as "rectangleContainer", _e as "rectangleMain", _f as "rectanglePreview", _10 as "roundedArrow", _11 as "roundedContainer", _12 as "roundedMain", _13 as "roundedOpenArrow", _14 as "roundedPreview" }
